import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Main from './main';
import FourZeroFour from './fourzerofour';
import CanonEquipmentRenderer from './CanonEquipmentRenderer/CanonEquipment';
import OfficeEquipmentRenderer from './OfficeEquipmentRenderer/OfficeEquipment';
import OfficeFurnitureRenderer from './OfficeFurnitureRenderer/OfficeFurniture';
import Campaign_Manager from './campaign_manager';
import Debug from './debug';

import { SearchForm } from './SearchComponents/SearchForm';
import StaticRenderer from './StaticPages/StaticRenderer';
import ContactUs from './contactus';
import RequestResult from './RequestSuccess';
import DocRoot from './DocTree/treeroot';
import FirebaseDB from './firebase';

class App extends Component {

    componentDidMount() {
        const db = new FirebaseDB("app");
        db.doMetrics();
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/root" component={DocRoot} />
                    <Route exact path="/debug" component={Debug} />
                    <Route exact path="/search" component={SearchForm} />
                    <Route exact path="/request/:result" component={RequestResult} />
                    <Route exact path="/contact/:productId" component={ContactUs} />
                    <Route exact path="/search/:searcharea/:searchterm" component={SearchForm} />
                    <Route exact path="/campaign_manager/:campaignId" component={Campaign_Manager} />
                    <Route exact path="/canon_equipment/:productId" component={CanonEquipmentRenderer} />
                    <Route exact path="/office_equipment/:productId" component={OfficeEquipmentRenderer} />
                    <Route exact path="/office_furntiure/:productId" component={OfficeFurnitureRenderer} />
                    <Route exact path="/static_page/:page" component={StaticRenderer} />
                    <Route exact path="/1" component={() => <Main r={true} />} />
                    <Route exact path="/" component={() => <Main r={false} />} />
                    <Route component={FourZeroFour} />
                </Switch>
            </BrowserRouter>
        )
    }
}


export default App;

